import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-back-button',
  templateUrl: './app-back-button.component.html',
  styleUrls: ['./app-back-button.component.scss'],
})
export class AppBackButtonComponent {
  @Input() label = 'Back';
  @Input() icon = 'arrow_back';
  @Output() back = new EventEmitter<void>();

  onBack(): void {
    this.back.emit();
  }
}
